import {Category, IAttributes, IProjectStore} from "../index";
import {AnyAction} from "redux";
import {compose} from "lodash/fp";

export default (store: IProjectStore, action: AnyAction): IProjectStore => {
  const attr = compose(
    mapId,
    filterByDependency,
    addAttr(action.attr),
    filterByCategory(action.attr),
    filterVents(action.attr),
    replaceGlass(store, action.attr),
    replaceColor(store, action.attr),
    mapAttr(store)
  );

  const sa = attr();

  return {
    ...store,
    selectedAttributes: sa,
  };
};

export const mapAttr = (store: IProjectStore) => () =>
  store.selectedAttributes.map((id) =>
    store.attributes.find((a) => a.id === id)
  );


const filterVents = (attr: IAttributes) => (attribs: IAttributes[]) => {
    const names = ["Krata wentylacyjna", "Podcięcie wentylacyjne", "Tuleje metalowe okrągłe i kwadratowe", "Tuleje tworzywowe"]

    const vent = attribs.find((a) => a.name === attr.name)

    if(names.includes(attr.name) && !vent){
      return attribs.filter(a => a.category !== Category.AddsColor && !names.includes(a.name))
    }
    return attribs
}

const replaceColor = (store: IProjectStore, attr:IAttributes) => (attributes: IAttributes[]) => {
  if(attr.category === Category.Variant && attributes.some(a=> a.category === Category.Color)) {
    const color = attributes.find(a => a.category === Category.Color)

    const newColor = store.attributes.find(a => a.slug.includes(attr.slug) && a.name === color?.name)

    if(newColor){
      let attribs = [...attributes]
      attribs.splice(attributes.indexOf(color as any), 1, newColor)
      return attribs
    }
  }
  return attributes
}

const replaceGlass = (store: IProjectStore, attr: IAttributes) => (attributes: IAttributes[]) => {
  if(attr.category === Category.Glass && attributes.some(a=> a.category === Category.Color)){
      if(attr.name.includes('VSG CZARNE')){
        const color = attributes.find(a => a.category === Category.Color)
        const newColor = store.attributes.find(sattr =>
          sattr.category === Category.Color && sattr.slug.replace('czarne_vsg_', '').includes(color?.slug || 'null') && sattr.slug.includes('czarne_vsg')
        )

        if(newColor){
          let attribs = [...attributes]
          attribs.splice(attributes.indexOf(color as any), 1, newColor)
          return attribs
        }
      } else {
        const color = attributes.find(a => a.category === Category.Color)
        if(color && color.name.includes('CZARNE VSG')){
          const newColor = store.attributes.find(sattr => sattr.category === Category.Color && sattr.slug.includes(color?.slug.replace('czarne_vsg_', '').trim() || 'null') && !sattr.slug.includes('czarne_vsg'))
          if(newColor){
            let attribs = [...attributes]
            attribs.splice(attributes.indexOf(color as any), 1, newColor)
            return attribs
          }
        }
      }
  }
  return attributes
}

export const filterByCategory = (attribute: IAttributes) => (attr: IAttributes[]) =>
  attr.filter((a) => a && ((a.category === 'adds') || (a.category !== attribute.category)));

const addAttr = (attribute: IAttributes) => (attr: IAttributes[]) => {

  console.log(attribute, attr)

  return attr.find (a => a.id === attribute.id)? [...attr.filter((a) => a.id !== attribute.id)]:[
    ...attr.filter((a) => a.id !== attribute.id),
    attribute,
  ];
}

export const filterByDependency = (attr: IAttributes[]) =>
  attr.filter((a) => {
        if(Object.entries(a.dependency).every(([key, arr]:any) => {
          if(key === 'special'){
            return true
          }
          const selectedCategory = attr.filter(s => s.category === key)
          const depArr = arr.filter(a => 'slug' in a)
          const notArr = arr.filter(a => !('slug' in a))

          const isDepMeet = depArr.length === 0 || depArr.some(a => selectedCategory.find(sel => sel.slug === a.slug))
          const isNotMeet = notArr.length === 0 || notArr.every(a => !selectedCategory.find(sel => sel.slug === a.not))

          return isDepMeet && isNotMeet
        })){
          return true
        } else {
          return false
        }
  }
  );

export const mapId = (attr: IAttributes[]) => {
  return attr.filter(Boolean).map((a) => a.id);
}
